// =============================
// Newsletter Popup + Floating Tab
// Basit Mantık: Her kullanıcıya sadece 1 kez göster
// =============================
(function () {
    const root = document.getElementById('am-newsletter-popup-root');
    if (!root) return;

    const overlay = root.querySelector('[data-nl-overlay]');
    const popup = root.querySelector('[data-nl-popup]');
    const closeBtn = root.querySelector('[data-nl-close]');
    const tabBtn = root.querySelector('[data-nl-tab]');
    const formEl = root.querySelector('[data-nl-form]');
    const formState = root.querySelector('[data-nl-form-state]');
    const successState = root.querySelector('[data-nl-success-state]');
    const codeWrap = root.querySelector('[data-nl-code-wrap]');
    const codeEl = root.querySelector('[data-nl-code]');
    const copyBtn = root.querySelector('[data-nl-copy]');
    const copiedEl = root.querySelector('[data-nl-copied]');

     // ======================================
    // iOS Fix: Overlay + Tab'i <body>'ye taşı
    // ama root'taki CSS değişkenlerini kaybetme
    // ======================================
    (function moveOverlayAndTabToBody() {
        if (!overlay && !tabBtn) return;

        // Root'tan CSS değişkenlerini oku
        const rootStyle = window.getComputedStyle(root);

        function copyCssVars(target, vars) {
            if (!target) return;
            vars.forEach(function (name) {
                const val = rootStyle.getPropertyValue(name);
                if (val) {
                    target.style.setProperty(name, val.trim());
                }
            });
        }

        // Popup için gereken değişkenler
        copyCssVars(overlay, [
            '--am-nl-popup-bg',
            '--am-nl-popup-mobile-max-width'
        ]);

        // Tab için gereken değişkenler
        copyCssVars(tabBtn, [
            '--am-nl-tab-font-size',
            '--am-nl-tab-padding-x',
            '--am-nl-tab-padding-y'
        ]);

        // Overlay'i body'ye al
        if (overlay && overlay.parentElement !== document.body) {
            document.body.appendChild(overlay);
        }

        // Tab'i body'ye al ve başlangıçta görünür hale getir
        if (tabBtn && tabBtn.parentElement !== document.body) {
            document.body.appendChild(tabBtn);
            tabBtn.classList.remove('hide');
        }
    })();

    if (!overlay || !popup || !tabBtn) return;

    const autoOpenDelay = parseInt(root.getAttribute('data-auto-open-delay') || '3', 10) * 1000;
    const autoCloseDelay = parseInt(root.getAttribute('data-auto-close-delay') || '5', 10) * 1000;

    // Cookie adı - popup gösterildi mi?
    const COOKIE_SHOWN = 'am_nl_shown';
    // Cookie adı - form dolduruldu mu?
    const COOKIE_SUBMITTED = 'am_nl_submitted';

    let closeTimeout = null;
    let scrollY = 0; // Remember scroll position when locking body

    // =====================
    // Cookie Helper Functions
    // =====================
    function setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    }

    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }
        return null;
    }

    // =====================
    // State Helpers
    // =====================
    function wasShown() {
        return getCookie(COOKIE_SHOWN) === '1';
    }

    function markAsShown() {
        setCookie(COOKIE_SHOWN, '1', 30); // 30 gün sakla
    }

    function wasSubmitted() {
        return getCookie(COOKIE_SUBMITTED) === '1';
    }

    function markAsSubmitted() {
        setCookie(COOKIE_SUBMITTED, '1', 365); // 1 yıl sakla
    }

    // =====================
    // UI Functions
    // =====================
    function lockBodyScroll() {
        // Lock body scroll while popup is open (iOS-safe pattern)
        const body = document.body;
        if (!body || body.classList.contains('body--nl-lock')) return;
        scrollY = window.scrollY || window.pageYOffset || 0;
        body.style.top = '-' + scrollY + 'px';
        body.classList.add('body--nl-lock');
    }

    function unlockBodyScroll() {
        // Restore body scroll after popup closes
        const body = document.body;
        if (!body || !body.classList.contains('body--nl-lock')) return;
        body.classList.remove('body--nl-lock');
        const y = scrollY || 0;
        body.style.top = '';
        window.scrollTo(0, y);
    }
    function showFormState() {
        if (formState) formState.hidden = false;
        if (successState) successState.hidden = true;
    }

    function showSuccessState() {
        if (formState) formState.hidden = true;
        if (successState) successState.hidden = false;
    }

    function closePopup() {
        clearTimeout(closeTimeout);
        overlay.classList.remove('is-visible');
        tabBtn.classList.remove('hide');
        unlockBodyScroll();
    }

    function openPopup(fromTab) {
        clearTimeout(closeTimeout);

        // Hangi içerik gösterilecek?
        if (wasSubmitted()) {
            showSuccessState();
        } else {
            showFormState();
        }

        overlay.classList.add('is-visible');
        tabBtn.classList.add('hide');
        lockBodyScroll();

        // Auto close timer (sadece auto-open için, tab'dan açılınca kapatma)
        if (!fromTab && autoCloseDelay > 0) {
            closeTimeout = setTimeout(closePopup, autoCloseDelay);
        }
    }

    // =====================
    // Initialization - Auto Open Logic
    // =====================

    // Popup daha önce gösterilmemişse, belirlenen süre sonra göster
    if (!wasShown() && autoOpenDelay >= 0) {
        setTimeout(function () {
            // Tekrar kontrol et (belki bu arada başka bir şey oldu)
            if (!wasShown()) {
                markAsShown(); // Artık gösterildi olarak işaretle
                openPopup(false);
            }
        }, autoOpenDelay);
    }

    // =====================
    // Event Listeners
    // =====================

    // Close Button
    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closePopup();
        });
    }

    // Overlay Outside Click
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
            closePopup();
        }
    });

    // Tab Button (Manuel açma - her zaman çalışır)
    tabBtn.addEventListener('click', function () {
        openPopup(true);
    });


    // =====================
    // Form Submit
    // =====================
    if (formEl) {
        formEl.addEventListener('submit', function (e) {
            e.preventDefault();

            const formData = new FormData(formEl);
            formData.set('form_type', 'customer');
            formData.set('contact[tags]', 'newsletter, Forms');

            fetch('/contact#newsletter', {
                method: 'POST',
                body: formData,
            })
                .then(function () {
                    markAsSubmitted();
                    showSuccessState();
                })
                .catch(function () {
                    markAsSubmitted();
                    showSuccessState();
                });
        });
    }

    // =====================
    // Copy Code
    // =====================
    function handleCopy() {
        if (!codeEl) return;
        const text = codeEl.textContent.trim();
        if (!text) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(function () { });
        }
        if (copiedEl) {
            copiedEl.hidden = false;
            setTimeout(function () { copiedEl.hidden = true; }, 1500);
        }
    }

    if (copyBtn) {
        copyBtn.addEventListener('click', function (e) {
            e.preventDefault();
            handleCopy();
        });
    }

    if (codeWrap) {
        codeWrap.addEventListener('click', function (e) {
            e.preventDefault();
            handleCopy();
        });
    }
})();
